import { Component, OnInit } from '@angular/core';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { ActivatedRoute, Router,NavigationStart } from '@angular/router';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
declare var ___MobileAgent___: any;
// import { PlatformLocation } from '@angular/common';
// import {Location} from "@angular/common";

export class CustomModalContext extends BSModalContext {
  public modalData: any;
}

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.css'],
  providers: [Modal]
})
export class TutorialComponent  implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  tutorialLinks=[];
  pageArray = [];
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal,
      private router: Router,
      public utilserv: utilityService,
      // private location: PlatformLocation,
    //  private location: Location
      ) {
        this.router.events.subscribe(event => {
          if (event instanceof NavigationStart) {
            this.dialog.close();
          }
        });
    this.modalData = this.dialog.context.modalData;
    // location.onPopState(() => this.continueClick());
    // this.location.subscribe(x => console.log(x));
  }

  ngOnInit() {
    this.getPageUrl(this.modalData.URL);
  }
  getPageUrl(route) {

    route = route.replace('/', '');
    this.utilserv.restGet(AppSettings.ICEMasterService + '/GetTutorial', true).subscribe(data => {
      this.tutorialLinks = data.TutorialLinks;
    });
  }
  continueClick() {
    this.dialog.close();
  }
  ngOnDestroy() {
  //  this.subscription.unsubscribe();
  }

  openTutorial(url) {
    ___MobileAgent___.OpenExternalLink(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/tutorial/tutorial.component.ts